export const GREEK_CHARACTERS = Array.from("ΑΆΒΓΔΕΈΖΗΉΙΊΪΚΛΜΝΞΟΌΠΡΣΤΥΎΫΦΩΏαάβγδεέζηήιίϊΐκλμνξοόπρσςτυύϋΰφωώ");
export const LATIN_CHARACTERS = Array.from("AAVGDEEZIIIIIKLMNXOOPRSTYYYFOOaavgdeeziiiiiiklmnxooprsstyyyyfoo");

export const GREEK_SYLLABLES_TO_LATIN_ELOT_743 = [
	["γχ", "nch"],
	["γξ", "nx"],
	["αυ(?=[ΘΚΞΠΣΤΦΧΨθκξπστφχψ|s|$])", "af"],
	["αύ(?=[ΘΚΞΠΣΤΦΧΨθκξπστφχψ|s|$])", "af"],
	["αυ(?=[ΑΓΕΗΙΟΥΩαγεηιουω]|s|$)", "av"],
	["αύ(?=[ΑΓΕΗΙΟΥΩαγεηιουω]|s|$)", "av"],
	["ευ(?=[ΘΚΞΠΣΤΦΧΨθκξπστφχψ|s|$])", "ef"],
	["εύ(?=[ΘΚΞΠΣΤΦΧΨθκξπστφχψ|s|$])", "ef"],
	["ευ(?=[ΑΓΕΗΙΟΥΩαγεηιουω]|s|$)", "ev"],
	["εύ(?=[ΑΓΕΗΙΟΥΩαγεηιουω]|s|$)", "ev"],
	["ηυ(?=[ΘΚΞΠΣΤΦΧΨθκξπστφχψ|s|$])", "if"],
	["ηύ(?=[ΘΚΞΠΣΤΦΧΨθκξπστφχψ|s|$])", "if"],
	["ηυ(?=[ΑΓΕΗΙΟΥΩαγεηιουω]|s|$)", "iv"],
	["ηύ(?=[ΑΓΕΗΙΟΥΩαγεηιουω]|s|$)", "iv"],
	["(?<=^|s)μπ(?=[α-ωΑ-ΩΆ-ώ])", "b"],
	["(?<=[α-ωΑ-ΩΆ-ώ])μπ(?=[α-ωΑ-ΩΆ-ώ]|$)", "mp"],
	["αι", "ai"],
	["οι", "oi"],
	["ου", "ou"],
	["ού", "ou"],
	["ει", "ei"],
	["ντ", "nt"],
	["τσ", "ts"],
	["τζ", "tz"],
	["γγ", "ng"],
	["γκ", "gk"],
	["θ", "th"],
	["χ", "ch"],
	["ψ", "ps"],
	["αυ", "af"],
	["αύ", "af"],
	["ευ", "ef"],
	["εύ", "ef"],
	["ηυ", "if"],
	["ηύ", "if"],
	["μπ", "b"],
	["Γχ", "Nch"],
	["Γξ", "Nx"],
	["Αυ(?=[ΘΚΞΠΣΤΦΧΨθκξπστφχψ|s|$])", "Af"],
	["Αύ(?=[ΘΚΞΠΣΤΦΧΨθκξπστφχψ|s|$])", "Af"],
	["Αυ(?=[ΑΓΕΗΙΟΥΩαγεηιουω]|s|$)", "Av"],
	["Αύ(?=[ΑΓΕΗΙΟΥΩαγεηιουω]|s|$)", "Av"],
	["Ευ(?=[ΘΚΞΠΣΤΦΧΨθκξπστφχψ|s|$])", "Ef"],
	["Εύ(?=[ΘΚΞΠΣΤΦΧΨθκξπστφχψ|s|$])", "Ef"],
	["Ευ(?=[ΑΓΕΗΙΟΥΩαγεηιουω]|s|$)", "Ev"],
	["Εύ(?=[ΑΓΕΗΙΟΥΩαγεηιουω]|s|$)", "Ev"],
	["Ηυ(?=[ΘΚΞΠΣΤΦΧΨθκξπστφχψ|s|$])", "If"],
	["Ηύ(?=[ΘΚΞΠΣΤΦΧΨθκξπστφχψ|s|$])", "If"],
	["Ηυ(?=[ΑΓΕΗΙΟΥΩαγεηιουω]|s|$)", "Iv"],
	["Ηύ(?=[ΑΓΕΗΙΟΥΩαγεηιουω]|s|$)", "Iv"],
	["(?<=^|s)Μπ(?=[α-ωΑ-ΩΆ-ώ])", "B"],
	["(?<=[α-ωΑ-ΩΆ-ώ])Μπ(?=[α-ωΑ-ΩΆ-ώ]|$)", "Mp"],
	["Αι", "Ai"],
	["Οι", "Oi"],
	["Ου", "Ou"],
	["Ού", "Ou"],
	["Ει", "Ei"],
	["Ντ", "Nt"],
	["Τς", "Ts"],
	["Τζ", "Tz"],
	["Γγ", "Ng"],
	["Γκ", "Gk"],
	["Θ(?=[α-ω])", "Th"],
	["Χ(?=[α-ω])", "Ch"],
	["Ψ(?=[α-ω])", "Ps"],
	["Αυ", "Af"],
	["Αύ", "Af"],
	["Ευ", "Ef"],
	["Εύ", "Ef"],
	["Ηυ", "If"],
	["Ηύ", "If"],
	["Μπ", "B"],
	["ΓΧ", "NCH"],
	["ΓΞ", "NX"],
	["ΑΥ(?=[ΘΚΞΠΣΤΦΧΨθκξπστφχψ|s|$])", "AF"],
	["ΑΥ(?=[ΑΓΕΗΙΟΥΩαγεηιουω]|s|$)", "AV"],
	["ΕΥ(?=[ΘΚΞΠΣΤΦΧΨθκξπστφχψ|s|$])", "EF"],
	["ΕΥ(?=[ΑΓΕΗΙΟΥΩαγεηιουω]|s|$)", "EV"],
	["ΗΥ(?=[ΘΚΞΠΣΤΦΧΨθκξπστφχψ|s|$])", "IF"],
	["ΗΥ(?=[ΑΓΕΗΙΟΥΩαγεηιουω]|s|$)", "IV"],
	["(?<=^|s)ΜΠ(?=[α-ωΑ-ΩΆ-ώ])", "B"],
	["(?<=[α-ωΑ-ΩΆ-ώ])ΜΠ(?=[α-ωΑ-ΩΆ-ώ]|$)", "MP"],
	["ΑΙ", "AI"],
	["ΟΙ", "OI"],
	["ΟΥ", "OU"],
	["ΟΎ", "OU"],
	["ΕΙ", "EI"],
	["ΝΤ", "NT"],
	["ΤΣ", "TS"],
	["ΤΖ", "TZ"],
	["ΓΓ", "NG"],
	["ΓΚ", "GK"],
	["Θ", "TH"],
	["Χ", "CH"],
	["Ψ", "PS"],
	["ΑΥ", "AF"],
	["ΕΥ", "EF"],
	["ΗΥ", "IF"],
	["ΜΠ", "B"],
];
